/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetAccountResponse } from './AssetAccountResponse';
import {
    AssetAccountResponseFromJSON,
    AssetAccountResponseFromJSONTyped,
    AssetAccountResponseToJSON,
    AssetAccountResponseToJSONTyped,
} from './AssetAccountResponse';

/**
 * 
 * @export
 * @interface AssetPersonalDataInventoryPart
 */
export interface AssetPersonalDataInventoryPart {
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataInventoryPart
     */
    causesDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataInventoryPart
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPersonalDataInventoryPart
     */
    hasOwnAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPersonalDataInventoryPart
     */
    hasFurtherAccount: boolean | null;
    /**
     * 
     * @type {Array<AssetAccountResponse>}
     * @memberof AssetPersonalDataInventoryPart
     */
    accounts: Array<AssetAccountResponse>;
    /**
     * 
     * @type {Date}
     * @memberof AssetPersonalDataInventoryPart
     */
    lastChangedAtUtc: Date | null;
}

/**
 * Check if a given object implements the AssetPersonalDataInventoryPart interface.
 */
export function instanceOfAssetPersonalDataInventoryPart(value: object): value is AssetPersonalDataInventoryPart {
    if (!('causesDescription' in value) || value['causesDescription'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('hasOwnAccount' in value) || value['hasOwnAccount'] === undefined) return false;
    if (!('hasFurtherAccount' in value) || value['hasFurtherAccount'] === undefined) return false;
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    if (!('lastChangedAtUtc' in value) || value['lastChangedAtUtc'] === undefined) return false;
    return true;
}

export function AssetPersonalDataInventoryPartFromJSON(json: any): AssetPersonalDataInventoryPart {
    return AssetPersonalDataInventoryPartFromJSONTyped(json, false);
}

export function AssetPersonalDataInventoryPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPersonalDataInventoryPart {
    if (json == null) {
        return json;
    }
    return {
        
        'causesDescription': json['causesDescription'],
        'phoneNumber': json['phoneNumber'],
        'hasOwnAccount': json['hasOwnAccount'],
        'hasFurtherAccount': json['hasFurtherAccount'],
        'accounts': ((json['accounts'] as Array<any>).map(AssetAccountResponseFromJSON)),
        'lastChangedAtUtc': (json['lastChangedAtUtc'] == null ? null : new Date(json['lastChangedAtUtc'])),
    };
}

export function AssetPersonalDataInventoryPartToJSON(json: any): AssetPersonalDataInventoryPart {
    return AssetPersonalDataInventoryPartToJSONTyped(json, false);
}

export function AssetPersonalDataInventoryPartToJSONTyped(value?: AssetPersonalDataInventoryPart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'causesDescription': value['causesDescription'],
        'phoneNumber': value['phoneNumber'],
        'hasOwnAccount': value['hasOwnAccount'],
        'hasFurtherAccount': value['hasFurtherAccount'],
        'accounts': ((value['accounts'] as Array<any>).map(AssetAccountResponseToJSON)),
        'lastChangedAtUtc': value['lastChangedAtUtc'] == null ? value['lastChangedAtUtc'] : value['lastChangedAtUtc'].toISOString(),
    };
}

